// extracted by mini-css-extract-plugin
module.exports = {"section":"BusinessCase_section__213e6","title":"BusinessCase_title__1FXwa","caseListWrapper":"BusinessCase_caseListWrapper__yVw_6","loadMoreBtn":"BusinessCase_loadMoreBtn__9o70u"};